
import React from "react";
import { Schemes } from "../../../../../../../utils";
import { i18nManager } from "../../../../../../../i18n";
import { Siren } from "../../../../../../shared/ConfirmDialog";
import { BaseService, IMember, ITournamentEdition, ITournamentEditionWebsite, SanitizedResponse, TournamentService } from "../../../../../../../services";
import { Checkbox, Form } from "@rivtn/noseur";

export interface VisibilitiesProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function Visibilities(props: VisibilitiesProps) {

    const { tournamentEdition } = props;
    const [init, setInit] = React.useState<boolean>(false);
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.settings.about.visibilities;
    const [tournamentEditionWebsite, setTournamentEditionWebsite] = React.useState<ITournamentEditionWebsite>(props.tournamentEditionWebsite);

    React.useEffect(() => {
        if (!init) {
            setInit(true);
            return;
        }
        updateWebsite();
    }, [tournamentEditionWebsite]);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none" }}>
        <Checkbox label={labels.enable_ad} defaultChecked={tournamentEditionWebsite.about_settings.enable_rivtn_ad} onChecked={(checked) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, about_settings: { ...tournamentEditionWebsite.about_settings, enable_rivtn_ad: checked } });
        }} />
        <hr />
        <Checkbox label={labels.show_rules} defaultChecked={tournamentEditionWebsite.about_settings.show_rules} onChecked={(checked) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, about_settings: { ...tournamentEditionWebsite.about_settings, show_rules: checked } });
        }} />
        <Checkbox label={labels.show_faqs} defaultChecked={tournamentEditionWebsite.about_settings.show_faqs} onChecked={(checked) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, about_settings: { ...tournamentEditionWebsite.about_settings, show_faqs: checked } });
        }} />
        <Checkbox label={labels.show_reviews} defaultChecked={tournamentEditionWebsite.about_settings.show_reviews} onChecked={(checked) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, about_settings: { ...tournamentEditionWebsite.about_settings, show_reviews: checked } });
        }} />
        <Checkbox label={labels.show_details} defaultChecked={tournamentEditionWebsite.about_settings.show_details} onChecked={(checked) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, about_settings: { ...tournamentEditionWebsite.about_settings, show_details: checked } });
        }} />
        <Checkbox label={labels.show_sponsors} defaultChecked={tournamentEditionWebsite.about_settings.show_sponsors} onChecked={(checked) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, about_settings: { ...tournamentEditionWebsite.about_settings, show_sponsors: checked } });
        }} />
    </Form>);

    function updateWebsite() {
        tournamentService.updateTournamentEditionWebsite(tournamentEdition.external_id, { ...tournamentEditionWebsite }).then(({ }: SanitizedResponse<ITournamentEditionWebsite>) => {
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError);
    }

}

export default Visibilities;
